import { useState } from "react";

const C = {
  gold: "#C09A5B",
  white: "#FFFFFF",
  ink: "#3D2E20",
  taupe: "#8B7361",
  border: "#E7E1D8",
};

const HELP_CONTENT = {
  prospects: {
    titre: "Gérer vos prospects",
    conseils: [
      "Commencez par qualifier le prospect avec le score de préqualification (0-15)",
      "Un score < 6 = prospect à risque",
      "Convertissez en client via le bouton 'Convertir en projet'",
    ],
  },
  acquisition: {
    titre: "Gérer vos prospects",
    conseils: [
      "Commencez par qualifier le prospect avec le score de préqualification (0-15)",
      "Un score < 6 = prospect à risque",
      "Convertissez en client via le bouton 'Convertir en projet'",
    ],
  },
  projets: {
    titre: "Gérer vos projets",
    conseils: [
      "Créez un projet pour chaque client",
      "Renseignez le budget et le client_email pour activer le portail client",
      "L'avancement se calcule depuis les jalons",
    ],
  },
  "mission-archi-interieure": {
    titre: "Mission Architecture Intérieure",
    conseils: [
      "Les 6 étapes se déverrouillent séquentiellement",
      "Validez chaque étape pour passer à la suivante",
      "L'IA génère les livrables à chaque étape",
    ],
  },
  "mission-opc": {
    titre: "Mission OPC",
    conseils: [
      "10 étapes de l'audit au SAV",
      "Documentez chaque visite terrain",
      "Les CR générés par l'IA sont directement utilisables",
    ],
  },
  "contrat-generateur": {
    titre: "Générateur de Contrat",
    conseils: [
      "Sélectionnez d'abord le type de mission",
      "Les annexes s'activent automatiquement",
      "La clause arbitrage est personnalisable",
      "Envoyez pour signature via Yousign",
    ],
  },
  "generateur-contrat": {
    titre: "Générateur de Contrat",
    conseils: [
      "Sélectionnez d'abord le type de mission",
      "Les annexes s'activent automatiquement",
      "La clause arbitrage est personnalisable",
      "Envoyez pour signature via Yousign",
    ],
  },
  finance: {
    titre: "Finance",
    conseils: [
      "Enregistrez chaque encaissement et décaissement",
      "Les UUIDs dans le tableau = IDs projets",
      "Connectez un projet pour voir son nom",
    ],
  },
  "vue-generale": {
    titre: "Finance",
    conseils: [
      "Enregistrez chaque encaissement et décaissement",
      "Les UUIDs dans le tableau = IDs projets",
      "Connectez un projet pour voir son nom",
    ],
  },
  jalons: {
    titre: "Jalons",
    conseils: [
      "Initialisez les 6 jalons standards YOMA",
      "Mettez à jour le statut après chaque paiement reçu",
      "Les alertes se déclenchent automatiquement",
    ],
  },
  "dashboard-promotion": {
    titre: "Promotion Immobilière",
    conseils: [
      "Créez d'abord vos acquéreurs dans Suivi des Ventes",
      "Les appels à paiement partent automatiquement par email",
      "Le contrat VEFA se génère depuis Contrat VEFA",
    ],
  },
  default: {
    titre: "Aide YOMA",
    conseils: [
    "Besoin d'aide ? Contactez-nous sur contact@yoma.design",
    "Documentation complète disponible sur yoma.design",
    "Tutoriel vidéo bientôt disponible",
    ],
  },
};

export default function HelpButton({ activeTab }) {
  const [open, setOpen] = useState(false);

  const help = HELP_CONTENT[activeTab] || HELP_CONTENT["default"];

  function resetOnboarding() {
    try {
      localStorage.removeItem("yoma_onboarding_done");
    } catch {
      // no-op
    }
    window.location.reload();
  }

  return (
    <>
      <button
        type="button"
        aria-label="Ouvrir l'aide"
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          right: 24,
          bottom: 24,
          width: 48,
          height: 48,
          borderRadius: "50%",
          border: "none",
          background: C.gold,
          color: C.white,
          fontFamily: "'Playfair Display', serif",
          fontSize: 20,
          cursor: "pointer",
          boxShadow: "0 8px 22px rgba(0,0,0,0.2)",
          zIndex: 1200,
        }}
      >
        ?
      </button>

      <div
        style={{
          position: "fixed",
          inset: 0,
          pointerEvents: open ? "auto" : "none",
          zIndex: 1300,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100%",
            width: 320,
            background: C.white,
            borderLeft: `4px solid ${C.gold}`,
            boxShadow: "-12px 0 30px rgba(0,0,0,0.12)",
            transform: open ? "translateX(0)" : "translateX(100%)",
            transition: "transform 0.25s ease",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              padding: "18px 16px 14px",
              borderBottom: `1px solid ${C.border}`,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 8,
            }}
          >
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, color: C.ink }}>
              Aide — {help.titre}
            </div>
            <button
              type="button"
              aria-label="Fermer l'aide"
              onClick={() => setOpen(false)}
              style={{
                border: "none",
                background: "transparent",
                color: C.taupe,
                cursor: "pointer",
                fontSize: 22,
                lineHeight: 1,
                padding: 0,
              }}
            >
              ×
            </button>
          </div>

          <div style={{ padding: "16px", overflowY: "auto", flex: 1 }}>
            <ul style={{ margin: 0, paddingLeft: 18, color: C.ink }}>
              {help.conseils.map((conseil) => (
                <li key={conseil} style={{ marginBottom: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 13, lineHeight: 1.55 }}>
                  {conseil === "Documentation complète disponible sur yoma.design" ? (
                    <>
                      Documentation complète disponible sur{" "}
                      <a
                        href="https://yoma.design"
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: C.gold, textDecoration: "underline" }}
                      >
                        yoma.design
                      </a>
                    </>
                  ) : (
                    conseil
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div style={{ padding: "14px 16px", borderTop: `1px solid ${C.border}`, display: "grid", gap: 8 }}>
            <button
              type="button"
              onClick={resetOnboarding}
              style={{
                border: "none",
                background: "transparent",
                color: C.gold,
                textDecoration: "underline",
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 13,
                padding: 0,
              }}
            >
              Revoir l'introduction
            </button>
            <a
              href="https://yoma.design"
              target="_blank"
              rel="noreferrer"
              style={{
                color: C.gold,
                textDecoration: "underline",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 13,
              }}
            >
              En savoir plus sur yoma.design
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;700&family=DM+Sans:wght@400;500;600;700&display=swap');
      `}</style>
    </>
  );
}

